import * as PopoverPrimitive from "@radix-ui/react-popover";
import {
  useEffect,
  useRef,
  useState,
  type ComponentPropsWithoutRef,
} from "react";

import { cn } from "../../lib/cn";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

type PopoverContentProps = ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Content
> & {
  portalContainer?: ComponentPropsWithoutRef<
    typeof PopoverPrimitive.Portal
  >["container"];
};

export function useNearestDialogPortalContainer<
  TElement extends HTMLElement,
>() {
  const ref = useRef<TElement>(null);
  const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(
    null,
  );

  useEffect(() => {
    setPortalContainer(
      ref.current?.closest<HTMLElement>('[role="dialog"]') ?? null,
    );
  }, []);

  return [ref, portalContainer] as const;
}

export function PopoverContent({
  className,
  align = "center",
  sideOffset = 8,
  portalContainer,
  ...rest
}: PopoverContentProps) {
  return (
    <PopoverPrimitive.Portal container={portalContainer}>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "bg-surface text-text shadow-overlay z-50 rounded-xl p-4 focus:outline-none",
          "data-[state=open]:animate-fade-in motion-reduce:animate-none",
          className,
        )}
        {...rest}
      />
    </PopoverPrimitive.Portal>
  );
}
